export const WHATSAPP_NUMBER = "593979103912";

export const content = {
  es: {
    boot: ["QUANTUM CENTURY", "// INICIALIZANDO SISTEMAS"],
    nav: {
      services: "Servicios",
      needs: "Soluciones",
      modular: "Modular",
      process: "Proceso",
      quote: "Solicitar cotización",
    },
    hero: {
      label: "// Ingeniería de software — Ecuador",
      line1: "Software que",
      line2: "evoluciona con",
      line3: "tu empresa.",
      sub: "Diseñamos, desarrollamos y adaptamos soluciones digitales para empresas que buscan automatizar procesos, mejorar su operación y transformar sus ideas en tecnología.",
      urgency: "De una idea a una solución funcional. Mientras lo piensas, tu competencia ya se está digitalizando.",
      ctaPrimary: "Solicitar cotización",
      ctaSecondary: "Conocer nuestros servicios",
      stats: [
        { v: "6", l: "líneas de solución" },
        { v: "360°", l: "cobertura digital" },
        { v: "100%", l: "a la medida" },
      ],
      frameTag: "SYS.QC-26 // ONLINE",
    },
    marquee: ["ERP", "CRM", "PWA", "APIs", "Automatización", "Dashboards", "Software a medida", "Integraciones", "Bases de datos", "Modernización", "Aplicaciones web", "Inteligencia comercial"],
    services: {
      label: "// Nuestros servicios",
      title: "Tecnología creada para hacer crecer tu negocio",
      sub: "Seis líneas de solución que cubren todo el ciclo digital de una empresa: desde su primera página web hasta la plataforma que dirige toda su operación.",
      details: "Ver capacidades",
      close: "Cerrar",
      items: [
        {
          id: "software-a-medida",
          num: "01",
          title: "Software a medida",
          tagline: "Tu empresa tiene procesos únicos. Tu software también puede tenerlos.",
          summary: "Sistemas empresariales, plataformas y automatización diseñados exclusivamente para tu forma de trabajar, no al revés.",
          features: [
            "Sistemas administrativos y de ventas",
            "Inventario, facturación y gestión documental",
            "Compras, proveedores y control de clientes",
            "Pedidos, cotizaciones y recursos humanos",
            "Paneles administrativos y dashboards",
            "Automatización de procesos repetitivos",
            "Modernización: de Excel a un sistema real",
            "Sistemas especializados según tu sector",
          ],
        },
        {
          id: "erp-crm",
          num: "02",
          title: "ERP & CRM",
          tagline: "Toda la operación de tu empresa en un solo sistema.",
          summary: "Gestión empresarial integral y relación comercial: ventas, inventario, clientes y reportes centralizados y conectados.",
          features: [
            "Módulos: ventas, compras, inventario y bodega",
            "Contabilidad, cuentas por cobrar y por pagar",
            "Clientes, proveedores y gestión documental",
            "Embudo de ventas y seguimiento de oportunidades",
            "Cotizaciones, pedidos y agenda comercial",
            "Reportes gerenciales e indicadores de desempeño",
            "Usuarios, permisos e historial de operaciones",
            "Diseño modular que crece con tu negocio",
          ],
        },
        {
          id: "web-apps-pwa",
          num: "03",
          title: "Aplicaciones Web & PWA",
          tagline: "Tu aplicación disponible desde cualquier dispositivo.",
          summary: "Apps empresariales modernas que se instalan directamente desde el navegador, sin depender de las tiendas de aplicaciones.",
          features: [
            "Instalables sin pasar por las tiendas de apps",
            "Un solo sistema: computadora, tablet, Android y iPhone",
            "Catálogos digitales y gestión de pedidos",
            "Sistemas para vendedores y operaciones internas",
            "Reservas, membresías y plataformas de servicios",
            "Portales de clientes y directorios digitales",
            "Un desarrollo, múltiples plataformas: menos costo",
          ],
        },
        {
          id: "desarrollo-web",
          num: "04",
          title: "Desarrollo Web",
          tagline: "Tu empresa también necesita una presencia digital profesional.",
          summary: "No nos limitamos a diseñar una página web: la conectamos con los sistemas y procesos de tu empresa.",
          features: [
            "Páginas corporativas y landing pages",
            "Catálogos digitales y portales informativos",
            "Sitios con áreas privadas y formularios avanzados",
            "Plataformas B2B, B2C y extranets para clientes",
            "Sistemas de reservas y pedidos en línea",
            "Aplicaciones SaaS",
            "Conexión real: web → formulario → CRM → vendedor → cotización",
          ],
        },
        {
          id: "integracion-adaptacion",
          num: "05",
          title: "Integración & Adaptación",
          tagline: "Haz que tus sistemas trabajen juntos.",
          summary: "Adaptamos la tecnología a tu empresa: conectamos tus programas, desarrollamos módulos nuevos y modernizamos lo que ya tienes.",
          features: [
            "Integración de sistemas mediante APIs",
            "Nuevos módulos para tu sistema actual",
            "Personalización de funcionalidades e interfaces",
            "Migración y reorganización de información",
            "Conexión web ↔ CRM ↔ ERP ↔ inventario",
            "Automatización del intercambio de datos",
            "Modernización de sistemas antiguos",
          ],
        },
        {
          id: "software-empresarial",
          num: "06",
          title: "Software Empresarial",
          tagline: "Licenciamiento y comercialización de software.",
          summary: "Comercializamos soluciones de software propias y de terceros, con licenciamiento y soporte continuo.",
          features: [
            "Licencias de software empresarial",
            "Soluciones digitales propias y de terceros",
            "Software especializado por sector",
            "Plataformas empresariales listas para operar",
            "Distribución de soluciones tecnológicas",
            "Soporte y evolución continua",
          ],
        },
      ],
    },
    needs: {
      label: "// Soluciones por necesidad",
      title: "¿Qué necesita tu empresa?",
      sub: "Sin tecnicismos. Dinos qué quieres lograr y te mostramos la solución exacta.",
      solutionLabel: "La solución",
      items: [
        { slug: "control", q: "Quiero controlar mejor mi empresa", a: "ERP empresarial", d: "Centraliza ventas, compras, inventario, contabilidad y reportes gerenciales en un solo sistema." },
        { slug: "sales", q: "Quiero organizar clientes y ventas", a: "CRM comercial", d: "Convierte información en oportunidades: prospectos, seguimiento, cotizaciones y embudo de ventas." },
        { slug: "automation", q: "Quiero automatizar un proceso", a: "Software a medida", d: "Menos tareas repetitivas: documentos, notificaciones, aprobaciones y reportes generados solos." },
        { slug: "app", q: "Quiero una aplicación para mi empresa", a: "Aplicaciones Web & PWA", d: "Una app instalable en cualquier dispositivo, sin depender de las tiendas de aplicaciones." },
        { slug: "web", q: "Quiero vender o mostrar mis servicios en internet", a: "Desarrollo web", d: "Presencia digital profesional conectada con tus sistemas y tu proceso de venta." },
        { slug: "adaptation", q: "Ya tengo un sistema pero necesito modificarlo", a: "Adaptación de software", d: "Nuevos módulos y funcionalidades sobre tu plataforma actual, cuando técnicamente sea posible." },
        { slug: "integration", q: "Tengo varios sistemas y quiero conectarlos", a: "Integraciones y APIs", d: "Haz que tus programas se hablen entre sí y elimina la doble digitación para siempre." },
        { slug: "excel", q: "Trabajo con Excel y procesos manuales", a: "Digitalización y automatización", d: "Convierte hojas de cálculo y formularios físicos en una plataforma digital centralizada." },
      ],
    },
    modular: {
      label: "// Desarrollo modular",
      title: "Empieza con lo que necesitas. Crece cuando lo necesites.",
      sub: "Nuestras soluciones se desarrollan de forma modular. Comienza con un núcleo y agrega módulos a medida que el negocio crece: la tecnología evoluciona junto con tu empresa.",
      baseTitle: "Núcleo inicial",
      addTitle: "Toca para agregar módulos",
      base: ["Clientes", "Ventas", "Inventario"],
      addons: ["Compras", "Proveedores", "Reportes", "CRM", "App móvil", "Automatizaciones", "Contabilidad", "RRHH"],
      counterLabel: "módulos activos",
      note: "Cada módulo se integra al mismo sistema. Sin migraciones dolorosas, sin empezar de cero.",
    },
    process: {
      label: "// Nuestro proceso",
      title: "Convertimos necesidades empresariales en soluciones digitales",
      steps: [
        { t: "Analizamos", d: "Conocemos tu negocio, procesos, necesidades y objetivos." },
        { t: "Diseñamos", d: "Definimos la estructura, funcionalidades y experiencia de la solución." },
        { t: "Desarrollamos", d: "Construimos la plataforma con las tecnologías adecuadas para el proyecto." },
        { t: "Implementamos", d: "Configuramos y ponemos en funcionamiento la solución." },
        { t: "Evolucionamos", d: "Incorporamos nuevas funcionalidades conforme cambian las necesidades del negocio." },
      ],
    },
    closing: {
      title1: "¿Tu empresa sigue operando",
      title2: "como hace 10 años?",
      sub: "Cada proceso manual es tiempo y dinero que tu competencia ya está ahorrando. Da el paso antes de quedarte un paso atrás.",
      primary: "Solicitar cotización",
      secondary: "Escríbenos por WhatsApp",
    },
    quote: {
      title: "Solicitar cotización",
      sub: "Cuéntanos sobre tu proyecto y te contactaremos para diseñar la solución.",
      name: "Nombre completo",
      company: "Empresa",
      email: "Correo electrónico",
      phone: "Teléfono / WhatsApp",
      service: "Servicio de interés",
      servicePlaceholder: "Selecciona un servicio",
      message: "Describe tu necesidad",
      messagePlaceholder: "Ej. Actualmente manejamos el inventario en Excel y queremos un sistema con reportes...",
      submit: "Enviar solicitud",
      sending: "Enviando...",
      success: "Solicitud enviada. Te contactaremos muy pronto.",
      error: "No se pudo enviar la solicitud. Intenta de nuevo o escríbenos por WhatsApp.",
    },
    footer: {
      tagline: "Software que evoluciona con tu empresa.",
      positioning: "Empresa ecuatoriana especializada en el diseño, desarrollo, adaptación y comercialización de soluciones de software para empresas.",
      navTitle: "Navegación",
      servicesTitle: "Servicios",
      contactTitle: "Contacto",
      location: "Quito, Ecuador",
      status: "Todos los sistemas operativos",
      rights: "© 2026 Quantum Century. Todos los derechos reservados.",
    },
    whatsapp: {
      label: "¿Conversamos?",
      aria: "Contactar por WhatsApp",
      message: "Hola Quantum Century, me interesa solicitar una cotización para mi empresa.",
    },
  },
  en: {
    boot: ["QUANTUM CENTURY", "// INITIALIZING SYSTEMS"],
    nav: {
      services: "Services",
      needs: "Solutions",
      modular: "Modular",
      process: "Process",
      quote: "Request a quote",
    },
    hero: {
      label: "// Software engineering — Ecuador",
      line1: "Software that",
      line2: "evolves with",
      line3: "your business.",
      sub: "We design, develop, and adapt digital solutions for companies looking to automate processes, improve operations, and turn ideas into technology.",
      urgency: "From an idea to a working solution. While you think about it, your competition is already going digital.",
      ctaPrimary: "Request a quote",
      ctaSecondary: "Explore our services",
      stats: [
        { v: "6", l: "solution lines" },
        { v: "360°", l: "digital coverage" },
        { v: "100%", l: "custom-built" },
      ],
      frameTag: "SYS.QC-26 // ONLINE",
    },
    marquee: ["ERP", "CRM", "PWA", "APIs", "Automation", "Dashboards", "Custom software", "Integrations", "Databases", "Modernization", "Web apps", "Business intelligence"],
    services: {
      label: "// Our services",
      title: "Technology built to grow your business",
      sub: "Six solution lines covering the entire digital cycle of a company: from its first website to the platform running its whole operation.",
      details: "View capabilities",
      close: "Close",
      items: [
        {
          id: "software-a-medida",
          num: "01",
          title: "Custom Software",
          tagline: "Your company has unique processes. Your software can too.",
          summary: "Enterprise systems, platforms, and automation designed exclusively around the way you work — not the other way around.",
          features: [
            "Administrative and sales systems",
            "Inventory, billing, and document management",
            "Purchasing, suppliers, and customer control",
            "Orders, quotes, and human resources",
            "Admin panels and dashboards",
            "Automation of repetitive processes",
            "Modernization: from spreadsheets to real systems",
            "Specialized systems for your industry",
          ],
        },
        {
          id: "erp-crm",
          num: "02",
          title: "ERP & CRM",
          tagline: "Your entire operation in a single system.",
          summary: "Comprehensive business management and customer relationships: sales, inventory, clients, and reports — centralized and connected.",
          features: [
            "Modules: sales, purchasing, inventory, and warehouse",
            "Accounting, accounts receivable and payable",
            "Customers, suppliers, and document management",
            "Sales pipeline and opportunity tracking",
            "Quotes, orders, and sales agenda",
            "Management reports and performance indicators",
            "Users, permissions, and operation history",
            "Modular design that grows with your business",
          ],
        },
        {
          id: "web-apps-pwa",
          num: "03",
          title: "Web Apps & PWA",
          tagline: "Your app available on any device.",
          summary: "Modern enterprise apps that install straight from the browser — no app store required.",
          features: [
            "Installable without app stores",
            "One system: desktop, tablet, Android, and iPhone",
            "Digital catalogs and order management",
            "Systems for sales teams and internal operations",
            "Bookings, memberships, and service platforms",
            "Customer portals and digital directories",
            "One build, multiple platforms: lower cost",
          ],
        },
        {
          id: "desarrollo-web",
          num: "04",
          title: "Web Development",
          tagline: "Your company also needs a professional digital presence.",
          summary: "We don't just design a website — we connect it to your company's systems and processes.",
          features: [
            "Corporate websites and landing pages",
            "Digital catalogs and information portals",
            "Sites with private areas and advanced forms",
            "B2B, B2C platforms, and customer extranets",
            "Online booking and ordering systems",
            "SaaS applications",
            "Real connection: web → form → CRM → sales rep → quote",
          ],
        },
        {
          id: "integracion-adaptacion",
          num: "05",
          title: "Integration & Adaptation",
          tagline: "Make your systems work together.",
          summary: "We adapt technology to your company: we connect your programs, build new modules, and modernize what you already have.",
          features: [
            "System integration through APIs",
            "New modules for your current system",
            "Customization of features and interfaces",
            "Data migration and reorganization",
            "Connection: web ↔ CRM ↔ ERP ↔ inventory",
            "Automated data exchange",
            "Legacy system modernization",
          ],
        },
        {
          id: "software-empresarial",
          num: "06",
          title: "Enterprise Software",
          tagline: "Software licensing and distribution.",
          summary: "We commercialize proprietary and third-party software solutions, with licensing and continuous support.",
          features: [
            "Enterprise software licensing",
            "Proprietary and third-party digital solutions",
            "Industry-specialized software",
            "Enterprise platforms ready to operate",
            "Distribution of technology solutions",
            "Continuous support and evolution",
          ],
        },
      ],
    },
    needs: {
      label: "// Solutions by need",
      title: "What does your company need?",
      sub: "No jargon. Tell us what you want to achieve and we'll show you the exact solution.",
      solutionLabel: "The solution",
      items: [
        { slug: "control", q: "I want better control of my company", a: "Enterprise ERP", d: "Centralize sales, purchasing, inventory, accounting, and management reports in one system." },
        { slug: "sales", q: "I want to organize clients and sales", a: "Commercial CRM", d: "Turn information into opportunities: prospects, follow-ups, quotes, and a sales pipeline." },
        { slug: "automation", q: "I want to automate a process", a: "Custom software", d: "Fewer repetitive tasks: documents, notifications, approvals, and reports generated automatically." },
        { slug: "app", q: "I want an app for my company", a: "Web Apps & PWA", d: "An installable app on any device, independent from app stores." },
        { slug: "web", q: "I want to sell or showcase my services online", a: "Web development", d: "A professional digital presence connected to your systems and your sales process." },
        { slug: "adaptation", q: "I have a system but need to modify it", a: "Software adaptation", d: "New modules and features on top of your current platform, whenever technically possible." },
        { slug: "integration", q: "I have several systems and want them connected", a: "Integrations & APIs", d: "Make your programs talk to each other and eliminate double data entry for good." },
        { slug: "excel", q: "I work with Excel and manual processes", a: "Digitalization & automation", d: "Turn spreadsheets and paper forms into a centralized digital platform." },
      ],
    },
    modular: {
      label: "// Modular development",
      title: "Start with what you need. Grow when you need to.",
      sub: "Our solutions are built modularly. Start with a core and add modules as the business grows: technology evolves alongside your company.",
      baseTitle: "Initial core",
      addTitle: "Tap to add modules",
      base: ["Clients", "Sales", "Inventory"],
      addons: ["Purchasing", "Suppliers", "Reports", "CRM", "Mobile app", "Automations", "Accounting", "HR"],
      counterLabel: "active modules",
      note: "Every module integrates into the same system. No painful migrations, no starting over.",
    },
    process: {
      label: "// Our process",
      title: "We turn business needs into digital solutions",
      steps: [
        { t: "We analyze", d: "We learn about your business, processes, needs, and goals." },
        { t: "We design", d: "We define the structure, features, and experience of the solution." },
        { t: "We develop", d: "We build the platform with the right technologies for the project." },
        { t: "We implement", d: "We configure and launch the solution into operation." },
        { t: "We evolve", d: "We add new features as your business needs change." },
      ],
    },
    closing: {
      title1: "Is your company still operating",
      title2: "like it did 10 years ago?",
      sub: "Every manual process is time and money your competition is already saving. Take the step before you fall one step behind.",
      primary: "Request a quote",
      secondary: "Message us on WhatsApp",
    },
    quote: {
      title: "Request a quote",
      sub: "Tell us about your project and we'll get in touch to design the solution.",
      name: "Full name",
      company: "Company",
      email: "Email address",
      phone: "Phone / WhatsApp",
      service: "Service of interest",
      servicePlaceholder: "Select a service",
      message: "Describe your need",
      messagePlaceholder: "E.g. We currently manage inventory in Excel and want a system with reports...",
      submit: "Send request",
      sending: "Sending...",
      success: "Request sent. We'll contact you very soon.",
      error: "We couldn't send your request. Please try again or message us on WhatsApp.",
    },
    footer: {
      tagline: "Software that evolves with your business.",
      positioning: "Ecuadorian company specialized in the design, development, adaptation, and commercialization of software solutions for businesses.",
      navTitle: "Navigation",
      servicesTitle: "Services",
      contactTitle: "Contact",
      location: "Quito, Ecuador",
      status: "All systems operational",
      rights: "© 2026 Quantum Century. All rights reserved.",
    },
    whatsapp: {
      label: "Let's talk",
      aria: "Contact via WhatsApp",
      message: "Hello Quantum Century, I'm interested in requesting a quote for my company.",
    },
  },
};
